/*Check if URL contains language subdomain*/
function getCurrentURL () {
  return window.location.href
}

var lang_url = getCurrentURL();
var lang_url =  lang_url.toLowerCase();


/*Add active langage flag to menu*/
if(lang_url.includes('nl.') === false &&lang_url.includes('fr.') === false && lang_url.includes('en.') === false) {
  document.getElementsByClassName("menu_lang_txt")[0].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/germany.png" alt="English" style="height:25px; width:25px;">';
  document.getElementsByClassName("menu_lang_txt")[1].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/germany.png" alt="English" style="height:25px; width:25px;">';
}
else if(lang_url.includes('en.') === true) {
  document.getElementsByClassName("menu_lang_txt")[0].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/netherlands.png?v=1621178603" alt="English" style="height:25px; width:25px;">';
  document.getElementsByClassName("menu_lang_txt")[1].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/netherlands.png?v=1621178603" alt="English" style="height:25px; width:25px;">';
}
else if(lang_url.includes('fr.') === true) {
  document.getElementsByClassName("menu_lang_txt")[0].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/france.png?v=1658157417" alt="English" style="height:25px; width:25px;">';
  document.getElementsByClassName("menu_lang_txt")[1].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/france.png?v=1658157417" alt="English" style="height:25px; width:25px;">';
}
else if(lang_url.includes('nl.') === true) {
  document.getElementsByClassName("menu_lang_txt")[0].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/netherlands-flag.png?v=1621178603" alt="English" style="height:25px; width:25px;">';
  document.getElementsByClassName("menu_lang_txt")[1].innerHTML='<img src="https://cdn.shopify.com/s/files/1/0471/1009/5006/files/netherlands-flag.png?v=1621178603" alt="English" style="height:25px; width:25px;">';
}



                    